var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"text":"","icon":""},on:{"click":_vm.onClick}},[_c('v-icon',[_vm._v(" mdi-exit-to-app ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }